import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js'; 
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {FundsService} from "../../../services/index.js";

import { initialFormData, initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';


const Transfer = (props) => {

    const [loading, setLoading] = useState(false);
    const userData = useSelector(state => state.authReducer);

    const [errors, setErrors] = useState({ ...initialErrors });
    const [formData, setFormData] = useState({toAgent: '', amountAgent: '', remarkAgent: ''})
    const [formDataWithdraw, setFormDataWithdraw] = useState({toAgentWithdraw: '', amountAgentWithdraw: '', remarkAgent: ''})
 
    const validateField = (fieldName, value) => {
      console.log(fieldName)
      const errorMessage = fieldValidation(fieldName, value);
      console.log(errorMessage)
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
      return errorMessage
    };

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      validateField(name, value);
    };

    const handleChangeWithdraw = (e) => {
      const { name, value } = e.target;
      setFormDataWithdraw((prevData) => ({ ...prevData, [name]: value }));
      validateField(name, value);
    };
 
  
    const fundAgent = (e) => {
      e.preventDefault();
      let hasErrors;
      Object.keys(formData).forEach(fieldName => {
        const error = validateField(fieldName, formData[fieldName]);
        if (error) {
            hasErrors = true;
        }
    });
    if(!hasErrors) {
      setLoading(true);
      const data = {
        transfer_amount: formData.amountAgent,
        funder_type:'AGENT',
        funder_id:formData.toAgent
      }
      FundsService.depositFund(data)
        .then(response => {
          toast.success(MESSAGES.FUND_DEPOSIT);
          setLoading(false);
          props.onSave();
        })
        .catch(error => {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          setLoading(false);
         
        });
      }
  
    }
  
    const withdrawAgent = (e) => {
      e.preventDefault();
      let hasErrors;
      Object.keys(formDataWithdraw).forEach(fieldName => {
        const error = validateField(fieldName, formDataWithdraw[fieldName]);
        if (error) {
            hasErrors = true;
        }
    });
    if(!hasErrors) {
      setLoading(true);
      const data = {
        transfer_amount: formDataWithdraw.amountAgentWithdraw,
        funder_type:'AGENT',
        funder_id:formData.toAgent
      }
      FundsService.withdrawFund(data)
        .then(response => {
          toast.success(MESSAGES.FUND_WITHDRAW);
          setLoading(false);
          props.onSave();
        })
        .catch(error => {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          setLoading(false);
         
        });
      }
  
    }

      useEffect(() => {
        setFormData({
          toAgent: props.rowData.user_id,
          name: props.rowData.full_name,
          amountAgent: '', 
          remarkAgent: ''
        })
     
      }, []);
    return (
      
      <>
       <LoaderOverlay loading={loading} />
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title> Funds</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
        <div className="container-fluid px-4" >
        {/* <h4 className="updatename updatename2" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Funds</h4> */}
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link active tbbtn" id="nav-home1-tab" data-bs-toggle="tab" data-bs-target="#nav-home1" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Agent Fund</button>
              <button className="nav-link tbbtn" id="nav-profile1-tab" data-bs-toggle="tab" data-bs-target="#nav-profile1" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" onclick="myFunction()" tabIndex={-1}>Withdraw Agent</button>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
            <div className="tab-pane fade show active" id="nav-home1" role="tabpanel" aria-labelledby="nav-home1-tab">
              <form method="post" onSubmit={fundAgent}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">FROM</label>

                        <select style={{color: '#74788d'}} className="pull_accounts" name="Pull_account" id="pull_account" disabled>
                          <option value="XXXXX-POOL-ACCOUNT-XXXXXX">{userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"}</option>
                        </select>
                       
                        {/* <SelectSearch search={true} options={options} disabled={true} name="language" placeholder="XXXXX-POOL-ACCOUNT-XXXXXX" /> */}

                        <span id="error_pull_account" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">TO</label>
                        <div className="select-search-container"><div className="select-search-value">

                          <strong>{formData.name}</strong>
                          </div>
                        </div>

                       
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number" className={`form-control ${errors.amountAgent ? 'is-invalid' : ''}`} id="to_amount" placeholder="Enter Your Amount" name="amountAgent" onChange={handleChange} />
                        {errors.amountAgent && <div className="invalid-feedback">{errors.amountAgent}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" onChange={handleChange} id="profile_conpass" placeholder="Enter Remark" name="remarkAgent" />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_agentfunds" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
            <div className="tab-pane fade" id="nav-profile1" role="tabpanel" aria-labelledby="nav-profile1-tab">
            <form method="post" onSubmit={withdrawAgent}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">FROM</label>
                        <div className="select-search-container"><div className="select-search-value">

                        <p>{formData.name}</p>
</div>
</div>
                        <span id="error_to_account" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">TO</label>
                        <select style={{color: '#74788d'}} className="pull_accounts" name="Pull_account" id="pull_account" disabled>
                          <option value="Pull Account">{userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"}</option>
                        </select>
                        <span id="error_pull_account" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number" className={`form-control ${errors.amountAgentWithdraw ? 'is-invalid' : ''}`}  id="to_amount" placeholder="Enter Your Amount" name="amountAgentWithdraw" onChange={handleChangeWithdraw} />
                        {errors.amountAgentWithdraw && <div className="invalid-feedback">{errors.amountAgentWithdraw}</div>}
                      
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" onChange={handleChangeWithdraw} id="profile_conpass" placeholder="Enter Remark" name="remarkAgentWithdraw" />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_agentwithdraw" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>


            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={props.onSave}>
            sumbit
          </Button> */}
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default Transfer;



